import React from "react";
import { Link } from "react-router-dom";

import anandImg from "../assets/anand.png";
import gurjotImg from "../assets/GS.jpg";
import ashuImg from "../assets/AM.jpg";

import PageHero from "../components/PageHero";
import { ArrowIcon, MailIcon, PhoneIcon } from "../components/Icons";
import { socialLinks } from "../socialLinks";

const team = [
  {
    name: "Anand Kumar",
    role: "Financial Adviser",
    focus: "Mortgages",
    image: anandImg,
    phone: "+64 22 185 2640",
    email: "anand@expertfinance.co.nz",
    bio: [
      "Anand is a certified Mortgage Adviser specialising in residential property lending, with over a decade of experience across mortgages, banking, home loans and refinancing. Most of his work is with first home buyers, and with people who suspect they are paying more interest than they need to.",
      "He holds the New Zealand Certificate in Financial Services (Level 5) and a Master's degree in Finance, Marketing, and Taxation. In practice that shows up as being able to explain why a bank has offered what it has, and what that offer will cost you over thirty years.",
      "He is happy to talk a situation through before anyone commits to anything, and he does a lot of that. If you want a second opinion on what your own bank has told you, he is the one to ask.",
    ],
  },
  {
    name: "Gurjot Singh",
    role: "Financial Adviser",
    focus: "Insurance",
    image: gurjotImg,
    phone: "+64 21 277 2642",
    email: "Gurjot@expertfinance.co.nz",
    bio: [
      "Gurjot Singh is a certified Financial Adviser based in Auckland, working in risk protection. He covers life, trauma, health and income protection. Like most of his clients, he’s juggling family and work while trying to plan further ahead than next month.",
      "His advice is down to earth. He has done his own budgeting and his own planning, so he tends to recommend cover that people will still be paying for in five years rather than the biggest policy on the table.",
      "Outside work he plays cricket most weekends and strums a mandolin. He volunteers around the community too.",
    ],
  },
  {
    name: "Ashu Maan",
    role: "Financial Adviser",
    focus: "Mortgages",
    image: ashuImg,
    phone: "+64 21 288 2641",
    email: "ashu@expertfinance.co.nz",
    bio: [
      "Ashu is a certified Mortgage Adviser specialising in residential property lending, with a background in mortgages, banking, home loans and refinancing. He works mostly with first home buyers, walking them through the lending process and looking for ways to bring the interest bill down.",
      "He asks a lot of questions before recommending anything, on the basis that a loan you cannot service in three years is not a good loan today. He holds the New Zealand Certificate in Financial Services (Level 5).",
      "He plays sport regularly and has a family of his own. That is probably why the conversation usually turns to what happens if things go wrong, rather than only what happens if they go right.",
    ],
  },
];

// One column per person: photo, name and contact details, then the bio
// underneath, so the three advisers read side by side.
function TeamMemberCard({ member }) {
  const { name, role, focus, image, phone, email, bio } = member;

  return (
    <article className="team-card">
      <div className="team-card-photo">
        <img src={image} alt={name} />
        <span className="team-card-focus">{focus}</span>
      </div>

      <div className="team-card-body">
        <h2 className="team-card-name">{name}</h2>
        <p className="team-card-role">{role}</p>

        <div className="team-card-contact">
          <a href={`tel:${phone.replace(/\s+/g, "")}`} className="team-card-link">
            <PhoneIcon size={16} />
            <span>{phone}</span>
          </a>
          <a href={`mailto:${email}`} className="team-card-link">
            <MailIcon size={16} />
            <span>{email}</span>
          </a>
        </div>

        <div className="team-card-bio">
          {bio.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </article>
  );
}

export default function OurTeamPage() {
  return (
    <div className="team-page">
      <PageHero
        kicker="Our Team"
        title="Meet the people behind Expert Finance"
        subtitle="The advisers you will actually be dealing with."
        overlap
      />

      <section className="team-section team-section-lead">
        <div className="team-grid">
          {team.map((member) => (
            <TeamMemberCard key={member.name} member={member} />
          ))}
        </div>
      </section>

      {/* One set of company accounts for the whole page */}
      <section className="team-section">
        <div className="team-social">
          <h2 className="team-social-title">Follow Expert Finance</h2>
          <div className="team-social-row">
            {socialLinks.map(({ label, icon, href }) => (
              <a
                key={label}
                className="team-social-btn"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* alt="" - the visible label right next to it already names it */}
                <img src={icon} alt="" />
                <span>{label}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band-section">
        <div className="cta-band">
          <div className="cta-band-text">
            <h2>Want to talk to one of us?</h2>
            <p>No cost for a first chat, and no obligation after it.</p>
          </div>
          <div className="cta-band-actions">
            <Link to="/contact" className="pill-btn pill-btn-light">
              Book a free chat
              <ArrowIcon />
            </Link>
            <a href="tel:+6492176765" className="cta-band-phone">
              or call 09-2176765
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
